export default class PasswordChangeModel{
    currentPassword="";
    newPassword="";
    newPasswordAgain="";

}